module.exports = __webpack_public_path__ + "img/36_not-a-checkmate.d1159ead.jpg";